export default __webpack_public_path__ + "static/media/for-multitaskers.4bedb237.png";